import * as keyapis_preset_v1_events_pb from "./v1/keyapis_preset_events_v1.pb";
import * as keyapis_preset_v1_preset_pb from "./v1/keyapis_preset_preset_v1.pb";
import * as keyapis_preset_v1_system_pb from "./v1/keyapis_preset_system_v1.pb";

export default {
  v1: {
    resources: {
      events: keyapis_preset_v1_events_pb,
      preset: keyapis_preset_v1_preset_pb,
      system: keyapis_preset_v1_system_pb,
    },
  },
};
